<template>
    <div class="frmhozzatartozok_formcont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>


        <div style="width:100%; box-sizing:border-box; text-align:center; color:#000;" v-html="result_text">
        </div>

    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'


export default {
  name: 'frmbefizetes_eredmeny',
  components: {
      GrcDB,
      GrcDialog,
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmBefizetesEredmeny_",

          InitDone:false,  

          result_text:"",

      }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmbefizetes_eredmeny", pCompName);
    },

    SetLang()
    {
        this.Init();
    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },

      async Init()
      {
        this.InitDone = false;

        let pSXN = "";

        if (GRCAPP_GetParameters.hasOwnProperty("SXN"))
        {
          pSXN = GRCAPP_GetParameters.SXN;
        }


        var QP = { 
            sOrderRef: pSXN
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.result_text = Q.RESULT[0].ResultText;

        this.InitDone = true;

      },

    async ShowLoginError(pText)
    {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", pText).then(res => { DialogResult = res; });
        
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();
    
  }

}


</script>


